<template>
  <div class="language-switcher">
    <form
      id="language-switcher-form"
      ref="languageForm"
      class="localization-form"
      accept-charset="UTF-8"
      action="/localization"
      enctype="multipart/form-data"
      method="post"
    >
      <input
        type="hidden"
        name="form_type"
        value="localization"
      >

      <input
        type="hidden"
        name="_method"
        value="put"
      >

      <div class="language-switcher__container">
        <ul class="language-switcher__list list-unstyled">
          <li
            v-for="(locale, index) of availableLocales"
            :key="locale.shop_locale.locale"
            class="language-switcher__item"
          >
            <a
              class="language-switcher__link"
              :class="locale.shop_locale.locale == selectedLocale && 'active'"
              href="#"
              :data-value="locale.shop_locale.locale"
              @click.prevent="handleLocaleChange(locale.shop_locale.locale)"
              v-text="locale.shop_locale.locale"
            />

            <span
              v-if="index !== availableLocales.length - 1"
              class="separator"
            />
          </li>
        </ul>

        <input
          v-model="selectedLocale"
          type="hidden"
          name="locale_code"
        >
      </div>
    </form>
  </div>
</template>

<script>

/**
 * Vue: Language switcher (language-switcher)
 * -----------------------------------------------------------------------------
 * Used to switch languages.
 *
 */
import { mapState } from 'vuex'

export default {
  name: 'LanguageSwitcher',

  data() {
    return {
      cnvsGlobal: true,
      currentLocale: window.cnvs.request.currentLocale,
      availableLocales: window.cnvs.request.availableLocales,
      selectedLocale: window.cnvs.request.currentLocale,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  mounted() {
    if (!this.isMobile && window.cnvs?.store?.permanentDomain === '//veronica-beard-canada.myshopify.com/') {
      const browserLang = window.navigator.language
      const manuallySet = localStorage.getItem('userSelectedLocale')
      const alreadyRedirected = sessionStorage.getItem('browserLangRedirectionDone')
      if (!manuallySet && !alreadyRedirected) {
        const prefersFrench = browserLang.startsWith('fr')
        const prefersEnglish = browserLang.startsWith('en')

        const isCurrentlyFrench = this.selectedLocale === 'fr'
        const isCurrentlyEnglish = this.selectedLocale === 'en'
        cnvs.SessionStorage('browserLangRedirectionDone', 'true')

        if (prefersFrench && !isCurrentlyFrench) {
          if (!window.location.pathname.startsWith('/fr')) {
            this.selectedLocale = 'fr'
            this.$nextTick().then(() => {
              this.$refs.languageForm.submit()
            })
          }
        }

        if (prefersEnglish && !isCurrentlyEnglish) {
          if (window.location.pathname.startsWith('/fr')) {
            this.selectedLocale = 'en'
            this.$nextTick().then(() => {
              this.$refs.languageForm.submit()
            })
          }
        }
      }
    }
  },

  methods: {
    handleLocaleChange(locale) {
      this.selectedLocale = locale
      this.$nextTick().then(() => {
        if (window.cnvs?.store?.permanentDomain === '//veronica-beard-canada.myshopify.com/') {
          cnvs.LocalStorage('userSelectedLocale', 'true')
          cnvs.SessionStorage('browserLangRedirectionDone', 'true')
        }
        this.$refs.languageForm.submit()
      })
    },
  },
}
</script>
